import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { AnyIfEmpty } from "react-redux";

export interface ISousModuleState {
  sousModules: ISousModule[];
  sousModulesByModule: ISousModule[];
  objSousModule: ISousModule;
  openDialog: boolean;
  valueEdit:string;
  valeurComboEdit:string;
}

export interface ISousModule {
  idModule: string;
  idSousModule: string;
  libelleSousModule: string;
}



export const sousModuleSlice: any = createSlice({
  name: "sousModule",
  initialState: {
    openDialog: false,
    sousModules: [],
    objSousModule: {},
    sousModulesByModule: [],
    valueEdit:"",
    valeurComboEdit:"",
  },
  reducers: {

    addSousModules: (state, action) => {
      const newModule: any = [...state.sousModules, action.payload]
      state.sousModules = newModule;
    },

    setSousModules: (state, action) => {
      state.sousModules = action.payload;
    },

    setObjSousModule: (state, action) => {
      state.objSousModule = action.payload;
    },

    setSousModulesByModule: (state, action) => {
      state.sousModulesByModule = action.payload;
    },

    setOpenDialog: (state, action) => {
      state.openDialog = action.payload;
    },

    deleteSousModule: (state, action) => {
      state.sousModules = state.sousModules.filter((sm: ISousModule) => sm.idSousModule !== action.payload);
    },

    editSousModule: (state, action) => {
      console.log("🚀 ~ file: sousModuleSlice.ts ~ line 59 ~ action.payload.idSousModule", action.payload.idSousModule)
      const newModule: any = state.sousModules.map((sm: ISousModule) => (sm.idSousModule === action.payload.idSousModule ? action.payload : sm))
      state.sousModules = newModule;
    },

    setValueEdit: (state, action) => {
      state.valueEdit = action.payload;
    },
    setValueComboEdit: (state, action) => {
      state.valeurComboEdit = action.payload;
    },

  }
});

export const {
  addSousModules,
  setSousModules,
  setObjSousModule,
  setSousModulesByModule,
  setOpenDialog,
  deleteSousModule,
  editSousModule,
  setValueEdit,
  setValueComboEdit
} = sousModuleSlice.actions;


export default sousModuleSlice.reducer;
